import { type Listing } from '@kijiji/generated/graphql-types'

import { ErrorBoundary } from '@/components/shared/error-boundary'
import { RealEstateListingTitle } from '@/components/srp/listing-card/real-estate-attributes/RealEstateListingTitle'
import { SearchListIntersectionObserver } from '@/domain/srp/SearchListIntersectionObserver'
import { RichCard } from '@/features/listing/components/rich-card/RichCard'

type RenderRichCardProps = {
  /**
   * Index of the listing card in the list
   */
  index: number
  /**
   * Listing data object
   */
  listing: Listing
  /**
   *  Boolean to indicate if title should show bed/bath/sqft
   */
  shouldOverrideRealEstateTitle?: boolean

  handleClick: () => void
}
export const RenderRichCard = ({
  index,
  listing,
  shouldOverrideRealEstateTitle,
  handleClick,
}: RenderRichCardProps) => {
  const titleOverride = shouldOverrideRealEstateTitle ? (
    <RealEstateListingTitle listing={listing} />
  ) : null
  return (
    <SearchListIntersectionObserver data-testid={`rich-card-list-item-${index}`} index={index}>
      <ErrorBoundary fingerprintId="RenderRichCard">
        <RichCard
          handleClick={handleClick}
          key={listing.id}
          index={index}
          listing={listing}
          showFooter
          mediaType="carousel"
          titleOverride={titleOverride}
        />
      </ErrorBoundary>
    </SearchListIntersectionObserver>
  )
}
